import React from 'react'
import { ReactComponent as Icon } from 'src/images/icon-expand.svg'
import useStyles from './styles'
import clsx from 'clsx'
import { useTheme } from '@mui/material'

interface Props {
  isExpanded: boolean
}

export const ToggleMoreClinicsIcon = ({ isExpanded }: Props) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <Icon
      fill={theme.palette.primary[900]}
      data-test="prev-week"
      className={clsx(classes.expandIcon, {
        [classes.expandedIcon]: isExpanded,
      })}
    />
  )
}
